/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-09 11:40:18
 * @FilePath: /zeelool-nextjs/src/components/Responsive/WebOnly.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useContext } from 'react';
import { EPlatform } from '../../utils/enums/platform-enum';
import { ResponsiveContext } from './ResponsiveProvider';

interface WebOnlyProps {
  /** 插槽内容 */
  children: React.ReactNode;
}
export default function WebOnly({ children }: WebOnlyProps) {
  const { deviceType } = useContext(ResponsiveContext);

  let isShow = true;
  if ([EPlatform.ANDROID, EPlatform.IOS, EPlatform.WAP].includes(deviceType)) {
    isShow = false;
  }

  return isShow ? <>{children}</> : <></>;
}
